const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/ECheckinSection.tsx';
import * as React from 'react';
import { forwardRef, ReactNode } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { ECheckinSectionProps } from '../types';
import { css } from '@emotion/css';
import { CIS4mStyled } from '@cistec/common_web/modules/CIS4m/components/CIS4mStyled';

type Props = ECheckinSectionProps & {
    children: ReactNode;
};

const eCheckinSectionCSS = css`
    & > h2 {
        font-weight: 400;
    }
`;

export const ECheckinSection = forwardRef((props: Props, ref) => {
    const formRef = useCIS4m(ref, undefined, () => {});

    return (
        <CIS4mStyled ref={formRef} className={eCheckinSectionCSS}>
            {props.children}
        </CIS4mStyled>
    );
});

ECheckinSection.displayName = 'ECheckinSection';

export default ECheckinSection;
